import { useState } from 'react';
import { useDispatch } from 'react-redux';

import { downloadBlobFile } from '@clatter/platform';
import { addNotification } from '../store';
import { useDownloadDocumentZipMutation } from '../services';

export const useDocumentZipDownload = () => {
  const dispatch = useDispatch();
  const [downloadZipMutation] = useDownloadDocumentZipMutation();
  const [isDownloading, setIsDownloading] = useState(false);

  const downloadZip = async ({ longpullId, fileName }: { longpullId: number; fileName: string }) => {
    if (!longpullId) {
      dispatch(addNotification({ type: 'error', message: 'Couldn\'t start the ZIP download.' }));
      return;
    }

    setIsDownloading(true);
    try {
      const blob = await downloadZipMutation({ longpullId, fileName }).unwrap();
      downloadBlobFile(blob, fileName);
    } catch (err) {
      dispatch(addNotification({ type: 'error', message: 'Download failed. Please try again.' }));
      console.error(err);
    } finally {
      setIsDownloading(false);
    }
  };

  return { downloadZip, isDownloading };
};
